<div class="flex row p-1 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Manually Check MOC Records
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>
<hr class="my-0">

<mat-dialog-content #pageContainer style="padding: 0px;max-height: 100%;">
    <div class=" grid grid-cols-4 gap-4 m-4 ">
        <div class="flex flex-col">
            <div>Field Name</div>
            <div class="font-medium text-lg">{{ failureNotificationRecord.fieldLongName }}</div>
        </div>
        <div class="flex flex-col">
            <div>Platform Name</div>
            <div class="font-medium text-lg">{{ failureNotificationRecord.platformLongName }}</div>
        </div>
        <div class="flex flex-col">
            <div>Well Name</div>
            <div class="font-medium text-lg">{{ failureNotificationRecord.wellLongName }}</div>
        </div>
        <div class="flex flex-col">
            <div>Well String Name</div>
            <div class="font-medium text-lg">{{ failureNotificationRecord.stringShortName }}</div>
        </div>

        <div class="flex flex-col">
            <div>Failure Date</div>
            <div class="font-medium text-lg">{{ handleFormatDate(failureNotificationRecord.failureDate, false) }}</div>
        </div>
        <div class="flex flex-col">
            <div>Failure Equipment</div>
            <div class="font-medium text-lg">{{ failureNotificationRecord.failureEquipment }}</div>
        </div>
        <div class="flex flex-col">
            <div>Overdue Day</div>
            <div class="font-medium text-lg">{{ failureNotificationRecord.overdueDays }}</div>
        </div>
    </div>

    <div class="divider text-gray-500 mt-8 mb-6">From MOC Records</div>

    <div class="overflow-y-auto p-2">
        <div class="flex gap-x-4 snap-x snap-mandatory">
            <ng-container *ngIf="mocRecordDetails.length == 0">
                <div class="min-w-[800px] shadow border border-gray-200 rounded-xl grid grid-cols-1 sm:grid-cols-4 gap-4 p-4
                 hover:border-gray-400 hover:shadow-md transition
                 focus-within:ring-2 focus-within:ring-primary/40">
                    <div class="col-span-4 flex items-center gap-3">
                        <h3 class="font-semibold">There are no MOC records registered!</h3>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="mocRecordDetails.length > 0">
                <ng-container *ngFor="let mocRecord of mocRecordDetails">
                    <label class="shrink-0">
                        <div class="min-w-[800px] shadow border border-gray-200 rounded-xl grid grid-cols-1 sm:grid-cols-4 gap-4 p-4
                 hover:border-gray-400 hover:shadow-md transition
                 focus-within:ring-2 focus-within:ring-primary/40"
                            [ngClass]="{'border-primary ring-2 ring-primary/30' : selectedWells.includes(mocRecord.id)}">
                            <div class="col-span-4 flex items-center gap-3">
                                <input type="checkbox" [value]="mocRecord.id"
                                    (change)="onCheckboxChange($event, mocRecord.id)"
                                    [checked]="selectedWells.includes(mocRecord.id)" />

                                <h3 class="font-semibold">{{ mocRecord.title }}</h3>
                            </div>

                            <div class="flex flex-col col-span-2">
                                <div class="text-primary">Key Issue</div>
                                <div>{{ mocRecord.keyIssues }}</div>
                            </div>
                            <div class="flex flex-col col-span-2">
                                <div class="text-primary">Requested By</div>
                                <div>{{ mocRecord.requestBy }}</div>
                            </div>

                            <div class="flex flex-col">
                                <div class="text-primary">Well String Name</div>
                                <div>{{ mocRecord.wellStringName }}</div>
                            </div>

                            <div class="flex flex-col">
                                <div class="text-primary">Ref No</div>
                                <div>{{ mocRecord.refNo }}</div>
                            </div>
                            <div class="flex flex-col">
                                <div class="text-primary">Extension No</div>
                                <div>{{ mocRecord.extNo }}</div>
                            </div>
                            <div class="flex flex-col">
                                <div class="text-primary">Stage</div>
                                <div>{{ mocRecord.stage }}</div>
                            </div>
                            <div class="flex flex-col">
                                <div class="text-primary">Start Date</div>
                                <div>{{ handleFormatDate(mocRecord.startDate, false) }}</div>
                            </div>
                            <div class="flex flex-col">
                                <div class="text-primary">End Date</div>
                                <div>{{ handleFormatDate(mocRecord.endDate, false) }}</div>
                            </div>
                            <div class="flex flex-col col-span-2">
                                <div class="text-primary">Remaining MOC Validity Day</div>
                                <div>{{ mocRecord.mocValidity }}</div>
                            </div>
                            <div class="flex flex-col">
                                <div class="text-primary">Approved Status</div>
                                <div [ngClass]="{
                                    'successBadge': mocRecord.approvalStatus == mocApprovalStatus.APPROVED,
                                    'failedBadge': mocRecord.approvalStatus == mocApprovalStatus.REJECTED,
                                    'warningBadge': mocRecord.approvalStatus ==  mocApprovalStatus.PENDING,
                              }">{{ mocRecord.approvalStatus }}</div>
                            </div>
                            <div class="flex flex-col">
                                <div class="text-primary">Status</div>
                                <div [ngClass]="{
                                'idleBadge': mocRecord.status == mocStatus.ACTIVE,
                                'successBadge': mocRecord.status == mocStatus.CLOSED || mocRecord.status == mocStatus.CLOSEOUT,
                                'failedBadge': mocRecord.status == mocStatus.REJECTED || mocRecord.status == mocStatus.CANCELLED,
                                'warningBadge': mocRecord.status == mocStatus.APPROVALPROCESS || mocRecord.status == mocStatus.EXTENSIONAPPROVALPROCESS
                          }">{{ mocRecord.status }}</div>
                            </div>
                        </div>
                    </label>
                </ng-container>
            </ng-container>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>
        Cancel
    </button>
    <button class="btn btn-primary" [disabled]="selectedWells.length == 0"
        (click)="submitMocAppTracking()">Submit</button>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>